"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tapeBuilderGraphToArtifactsDocument = exports.artifactsDocumentToTapeBuilderGraph = void 0;
const convertor_1 = require("./convertor");
const tapeBuilder_1 = require("./tapeBuilder");
const artifactsDocumentToTapeBuilderGraph = ({ artifactsDocument, }) => {
    return convertor_1.convertor.artifactsDocumentToTapeBuilder({
        artifactsDocument,
    });
};
exports.artifactsDocumentToTapeBuilderGraph = artifactsDocumentToTapeBuilderGraph;
// TapeBuilderNodes => ArtifactsDocument conversion requires
// an instance of tapeBuilderRuntime to validate the operation configurations
// we need to pass a callback to create such instance to break circular dependency.
const tapeBuilderGraphToArtifactsDocument = ({ graph, creditFacilities, loanProducts, artifactDocumentId, }) => {
    return convertor_1.convertor.tapeBuilderToArtifactsDocument({
        artifactDocumentId,
        graph,
        creditFacilities,
        loanProducts,
        createTapeBuilder: tapeBuilder_1.createTapeBuilder,
    });
};
exports.tapeBuilderGraphToArtifactsDocument = tapeBuilderGraphToArtifactsDocument;
//# sourceMappingURL=graphConversion.js.map